export const ProgressHeader = () => {
  return (
    <div>
      <h1 className="text-2xl font-heading font-bold text-foreground">Tu Progreso</h1>
      <p className="text-sm text-muted-foreground mt-1">El cuerpo responde a lo que haces todos los días, no de vez en cuando. 💚</p>
    </div>
  );
};
